import {
  FlagIcon,
  IconButton,
  MapMarkerIcon,
  PencilAltIcon,
  Pill,
  ProfileHeader,
  useModal,
  useRouter,
} from '@forgeglobal/design-framework'
import { IssuerHeaderModal } from 'components/issuers/IssuerHeaderModal'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import { renderLocation } from 'util/AccountUtils'
import { useIssuerHeaderQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'
import compact from 'lodash/compact'
import moment from 'moment'

export const IssuerHeader = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useIssuerHeaderQuery({ variables: { issuerId: match.params.id } })
  const account = data?.account
  const issuerProfile = account?.issuer_account
  const company = issuerProfile?.company
  const lastRound = company?.last_round
  const canTrade = issuerProfile?.is_actionable ?? false
  const lastRoundDate = lastRound?.round_date
  const lastRoundDateText = lastRoundDate ? ` (as of ${moment(lastRoundDate).format('MMM YYYY')})` : ''
  const lastRoundSubtitle = lastRound
    ? `Valuation ${formatAbbreviatedMoney(lastRound.valuation)}${lastRoundDateText}`
    : ''
  const companyLogo = company?.logo_url ?? ''

  const pills = compact([canTrade && <Pill label="Can trade" />])
  const [showModal, hideModal] = useModal(() => {
    return <IssuerHeaderModal hideModal={hideModal} accountId={match.params.id} />
  }, [match.params.id])

  const renderedLocation = renderLocation({
    city: account?.city,
    state: account?.state,
    country: account?.country,
  })
  const flagDetails = account?.notes ?? null
  const details = compact([
    renderedLocation && {
      icon: <MapMarkerIcon />,
      content: renderedLocation,
    },
    flagDetails && {
      icon: <FlagIcon />,
      content: flagDetails,
    },
  ])
  const control = (
    <IconButton data-cypress="edit-account-header-button" onClick={showModal}>
      <PencilAltIcon />
    </IconButton>
  )
  return (
    <ProfileHeader
      title={account?.name ?? ''}
      subtitle={lastRoundSubtitle}
      avatarImg={companyLogo}
      details={details}
      secondaryControl={control}>
      {pills}
    </ProfileHeader>
  )
}
